// Canonical enums — kept in one place so import/export, dropdowns, and
// security checks all see the same values.

export const STAGES = [
  'Prospect',
  'Contacted',
  'Engaged',
  'Qualified',
  'Presentation',
  'Negotiation',
  'Closed Won',
  'Closed Lost',
  'Nurture'
];

export const ACTIVE_STAGES = STAGES.filter(s => !['Closed Won', 'Closed Lost', 'Nurture'].includes(s));

export const STAGE_COLORS = {
  'Prospect':     'bg-slate-100 text-slate-800 border-slate-300',
  'Contacted':    'bg-blue-100 text-blue-800 border-blue-300',
  'Engaged':      'bg-indigo-100 text-indigo-800 border-indigo-300',
  'Qualified':    'bg-violet-100 text-violet-800 border-violet-300',
  'Presentation': 'bg-amber-100 text-amber-800 border-amber-300',
  'Negotiation':  'bg-orange-100 text-orange-800 border-orange-300',
  'Closed Won':   'bg-emerald-100 text-emerald-800 border-emerald-300',
  'Closed Lost':  'bg-red-100 text-red-800 border-red-300',
  'Nurture':      'bg-teal-100 text-teal-800 border-teal-300'
};

export const PRODUCTS = ['Managed IT', 'Odoo Advisory', 'NAWIRI', 'Cybersecurity', 'Other'];

export const SOURCES = [
  'Apollo',
  'LinkedIn Personal',
  'LinkedIn Company',
  'Lusha Email',
  'Referral',
  'Cold Call',
  'Event',
  'Website',
  'Historic CRM'
];

export const ROLES = ['admin', 'sales'];

// Default weekly targets — admin can override in /config/global at runtime.
export const DEFAULT_TARGETS = {
  newProspectsEnriched: 15,
  outreachEmailsSent: 25,
  discoveryCallsCompleted: 3,
  qualifiedLeads: 0,
  founderPresentations: 0,
  proposalsSent: 0,
  retainersClosed: 0
};
